import { useContext } from "react";
import { AppContext } from "../App";
import Label from "./Label";

export default function Maintenance({ title = null, message = null, action = null }) {
	const { settings } = useContext(AppContext);
	return (
		<div className="maintenance">
			<div className="content">
				<div className="logo">
					<img src={settings.website.logo} />
				</div>
				<div className="text">
					{title ? <h2>{title}</h2> : null}
					<div>{message || <Label number={210} />}</div>
					{action ? <div className="maintenance-action mt-2">{action}</div> : null}
				</div>
			</div>
		</div>
	);
}
